// Départ vers Keycloak (CRM-301) : le parcours est écrit dans le stockage de session, puis seulement la page part.
// Deux commandes Elm séparées (écriture, navigation) ne garantissaient pas l'écriture avant le déchargement de la
// page : au retour, le parcours manquait et la connexion échouait. Ici l'ordre est celui des instructions.
// `depart` : `{ parcours, adresse }`. Un stockage qui refuse l'écriture n'empêche pas le départ : Elm refusera le
// retour sans parcours gardé et l'écran le dira.
export function garderParcoursEtPartir(stockage, emplacement, cle, depart) {
  try {
    stockage.setItem(cle, JSON.stringify(depart.parcours));
  } catch {
    // Rien à faire ici.
  }
  emplacement.assign(depart.adresse);
}
